export default __webpack_public_path__ + "static/dream_production_logo-93aedf6f30979e8dfb2074fb92412b8e.svg";